module.exports = __webpack_public_path__ + "static/media/icon_shipment.b6666f5a.svg";